// extracted by mini-css-extract-plugin
export default {"outerDiv":"UserDetCard_outerDiv__CvYpK","innerDiv":"UserDetCard_innerDiv__-3rQ7","imgBox":"UserDetCard_imgBox__CHu41","img":"UserDetCard_img__WajRB","txt":"UserDetCard_txt__2JlJR"};